// El SCROLL de la conversación del Agente, la parte pura —
// ADR-2026-09-13-el-scroll-del-agente.
//
// Cuatro reglas, todas sin DOM para poder probarlas:
//   • Dónde quedó cada chat: un mapa a nivel de MÓDULO, por id de chat. Vive fuera del
//     componente porque la conversación se desmonta al cerrar el panel o al irse a otra
//     pantalla, y la posición tiene que sobrevivir a eso.
//   • Al abrir: la posición guardada, o el fondo (lo último que pasó) si no hay ninguna.
//   • Cerca del fondo: con menos de `UMBRAL_CERCA_PX` por delante no hace falta el botón
//     de "ir al final"; con menos de `UMBRAL_REENGANCHE_PX` el usuario "llegó" y la
//     conversación vuelve a seguirlo sola mientras el agente responde.
//   • Un gesto HACIA ARRIBA (rueda con deltaY negativo, o el dedo bajando en touch) corta
//     el seguimiento en el acto, aunque todavía esté cerca del fondo: si lo movió, no se
//     lo tira para abajo.

export const UMBRAL_CERCA_PX = 140;
export const UMBRAL_REENGANCHE_PX = 24;

export interface MedidasScroll {
  scrollTop: number;
  scrollHeight: number;
  clientHeight: number;
}

export const distanciaAlFondo = (m: MedidasScroll): number =>
  Math.max(0, m.scrollHeight - m.scrollTop - m.clientHeight);

export const estaCercaDelFondo = (m: MedidasScroll, umbral: number = UMBRAL_CERCA_PX): boolean =>
  distanciaAlFondo(m) <= umbral;

const posiciones = new Map<string, number>();

export const guardarPosicion = (clave: string, scrollTop: number): void => {
  posiciones.set(clave, Math.max(0, Math.round(scrollTop)));
};

export const posicionGuardada = (clave: string): number | undefined => posiciones.get(clave);

export const olvidarPosicion = (clave: string): void => {
  posiciones.delete(clave);
};

/** Dónde arrancar al montar: lo guardado para ese chat, o el fondo. */
export const posicionInicial = (clave: string, scrollHeight: number): number =>
  posiciones.has(clave) ? (posiciones.get(clave) as number) : scrollHeight;

/** ¿El gesto es hacia arriba? Rueda: deltaY negativo. Touch: el dedo BAJA (la Y crece)
 *  más que un temblor, que es lo que hace subir el contenido. */
export function gestoHaciaArriba(g: {
  deltaY?: number;
  toqueDesdeY?: number;
  toqueHastaY?: number;
}): boolean {
  if (typeof g.deltaY === 'number') return g.deltaY < 0;
  if (typeof g.toqueDesdeY === 'number' && typeof g.toqueHastaY === 'number') {
    return g.toqueHastaY - g.toqueDesdeY > 4;
  }
  return false;
}
